import { Bar } from '@ant-design/plots';
import React, { useEffect, useState } from 'react';

const CheckboxType = ({ answers, onReady }) => {


  const [data, setData] = useState([]);

  useEffect(() => {

    const counts = {};

answers.forEach((answer) => {
  let values = [];

  try {
    if (typeof answer?.value === 'string' && answer?.value.trim().startsWith('[')) {
      const parsed = JSON.parse(answer.value);
      values = Array.isArray(parsed) ? parsed : [parsed];
    } else {
      values = [answer?.value];
    }
  } catch (e) {
    values = [answer?.value];
  }

  values.forEach((val) => {
    counts[val] = (counts[val] || 0) + 1;
  });
});

    const total = Object.values(counts).reduce((acc, cur) => acc + cur, 0);

    const formatted = Object.entries(counts).map(([type, value]) => ({
      type,
      value,
      percent: Math.round((value / total) * 100), 
    }));

    setData(formatted);
  }, [answers]);

  const config = {
    data,
    xField: 'value',  
    yField: 'type',    
    layout: 'horizontal',
    colorField: 'type',
    label: {
      content: (originData) => `${originData?.percent}%`, 
      position: 'left',
      style: {
        fill: '#000',
        fontWeight: 'bold',
      },
    },
    state: {
      unselected: { opacity: 0.5 },
      selected: { lineWidth: 3, stroke: 'red' },
    },
    interactions: [{ type: 'element-selected' }],
 
  };

  return (
   <div style={{ height: 250 }}>
    {((data.length > 0) && answers) && <Bar {...config} onReady={(plot) => {
        if (onReady) onReady(plot); 
      }} />}
  </div>
  );
};

export default CheckboxType;
